//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCheckVerifyPermissions, getApplicantInfo, baseInfo, applyInfo, getRecord, coinData, BASE, ECARGO_PATH } from '@/api/apis';
import * as api from '@/api/persionInfo.js';
export default {
  name: 'PolicysearchQuery',
  data: function data() {
    var validateRequiredFlout = function validateRequiredFlout(rule, value, callback) {
      console.log('value==', value);

      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^\d+(\.\d{1,2})?$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入数字或小数点后两位！'));
        }
      }
    };

    var validateRequiredFlout1 = function validateRequiredFlout1(rule, value, callback) {
      console.log('value==', value);

      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^\d+(\.\d{1,2})?$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入数字或小数点后两位！'));
        }
      }
    };

    var validateInt = function validateInt(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validateInt1 = function validateInt1(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validatePolicyNo = function validatePolicyNo(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[A-Za-z0-9]+$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('只能输入数字和英文字符!'));
        }
      }
    };

    var validatePercent = function validatePercent(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          if (Number(value) > 100) {
            callback(new Error('占比不允许超过100%'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validatePercent1 = function validatePercent1(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          if (Number(value) > 100) {
            callback(new Error('占比不允许超过100%'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    return {
      formData: {
        enterpriseInfo: {
          // 平台注册信息
          createTime: '',
          // 创建时间
          accountType: '',
          // 账户类型
          businessType: '',
          // 100-货物运输保险  101-短期出口贸易信用险
          registAddress: '',
          // 注册地址
          businessAddress: '',
          // 营业地址
          companyType: '',
          // 公司类型
          businessNature: '',
          // 经营性质
          isListed: '',
          // 是否上市
          businessScope: '',
          // 投保业务范围
          businessStartYear: '',
          // 出口业务经营历史
          businessImg: '',
          // 营业执照
          enterName: '',
          // 企业中文名称
          enterEnName: '',
          // 企业英文名称
          enterAddress: '',
          // 住所
          authPersonName: '',
          // 法定代表人
          companyDate: '',
          // 成立日期
          orgCode: '',
          // 统一社会信用代码证
          businessStartDate: '',
          // 营业期限起
          businessEndDate: '',
          // 营业期限至
          businessRange: '',
          // 营业范围
          // 上面不可修改
          authPersonIdeType: '',
          // 法定代表人证件类型
          authPersonIdeNo: '',
          // 法定代表人证件号码
          customsRegisterCode: '',
          // 海关十位编码
          // 联系人信息
          linkmanName: '',
          // 联系人姓名
          linkmanIdeType: '',
          // 联系人证件类型
          linkmanIdeNo: '',
          // 联系人证件号码
          linkmanMobile: '',
          // 移动电话
          linkmanEmail: '',
          // 电子邮箱
          linkmanAddress: '',
          // 联系地址
          linkmanPhone: '',
          // 联系电话
          // 系统信息
          password: '',
          // 密码
          confirmPassword: '',
          // 确认密码
          sysCreditDtoList: [],
          accountApplicationDtos: []
        }
      },
      isSureUpload: false,
      // 上传影像按钮的显示与隐藏
      isSelect: false,
      electActive: false,
      userDisable: false,
      firstDate: {
        year: '',
        mouth: '',
        day: ''
      },
      secondDate: {
        year: '',
        mouth: '',
        day: ''
      },
      isUser: false,
      BASE_PATH: BASE + ECARGO_PATH,
      rulesData: {
        policyNo: [{
          required: true,
          trigger: 'blur',
          validator: validatePolicyNo
        }],
        selectRule: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }],
        notInputRule: [{
          required: true,
          trigger: 'blur',
          message: '请输入'
        }],
        numRule: [{
          required: true,
          trigger: 'blur',
          validator: validateInt
        }],
        numRule2: [{
          required: true,
          trigger: 'blur',
          validator: validateInt1
        }],
        percentRule: [{
          required: true,
          trigger: 'blur',
          validator: validatePercent
        }],
        percentRule1: [{
          required: true,
          trigger: 'blur',
          validator: validatePercent1
        }],
        notNullInputRule: [{
          required: true,
          trigger: 'blur',
          validator: validateRequiredFlout
        }],
        notNullInputRule1: [{
          required: true,
          trigger: 'blur',
          validator: validateRequiredFlout1
        }]
      },
      applicantRules: {
        insuredName: [{
          required: true,
          message: '请输入投保人名称',
          trigger: 'blur'
        }],
        businessScope: [{
          required: true,
          message: '请输入拟投保范围',
          trigger: 'blur'
        }]
      },
      checkedItem: [],
      insureRange: [],
      // 投保范围
      listOpt: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],
      companyList: [],
      // 保险公司集合
      attAgencyList: [],
      // 分支机构
      insureApplyRecord: [],
      // 申请单流转记录
      activeName: 'first',
      idCardList: [],
      // 证件类型
      country: [],
      fileBitList: [],
      dialogImageUrl: '',
      salesmanList: [],
      dialogVisible: false,
      checked: false,
      businessNatures: [],
      // 经营性质
      identifyType: [],
      // 法人证件类型
      companyType: [],
      // 公司类型
      allDisabled: false,
      // 查看view  禁用
      coinList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    // // 获取保险公司集合
    // getCompanyList().then(res => {
    //   this.companyList = res
    //   console.log('保险公司res', res)
    // })
    // // 获取分支机构
    // getAgencyLisy().then(res => {
    //   console.log('分支机构res', res)
    //   this.attAgencyList = res
    // })
    // 获取币种
    // this.getCoinData()
    // this.applyFunction()
    this.baseFunction();
    this.getUserInfo();
    console.log('this.$route.params==', this.$route);
    this.getCountry();

    if (this.$route.params.type == 'view') {
      this.allDisabled = true;
      console.log('查看--');
    }

    if (this.$route.params.type == 'view' || this.$route.params.type == 'edit') {
      this.isSureUpload = true;
    }

    if (this.$route.params.userType == '02') {
      this.isUser = true;
      this.userDisable = true;
      console.log('this.userDisable==', this.userDisable);
    }

    console.log('meiyuan复制', this.$route.params.userType);

    if (this.$route.params.userType == '02') {
      console.log('meiyuan复制', this.$route.params.type);

      if (this.$route.params.type == 'edit') {
        if (this.formData.premiumCurrency == '') {
          this.formData.premiumCurrency = 'USD';
          this.formData.premiumCurrencyName = '美元';
        }
      }
    }
  },
  methods: {
    setXEmail: function setXEmail(email) {
      // 邮箱 脱敏
      // 2022-01-11 判断如果邮箱是多个的话需要特殊处理
      var emailArr = [];

      if (email.search(',') != -1) {
        emailArr = email.split(',');
        var new_email = '';

        for (var j = 0; j < emailArr.length; j++) {
          if (String(emailArr[j]).indexOf('@') > 0) {
            var str = emailArr[j].split('@');
            var _s = '';

            if (str[0].length > 3) {
              // @前面多于3位
              for (var i = 3; i < str[0].length; i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 3) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 3) + _s + '@' + str[1];
              }
            } else {
              // @前面小于等于于3位
              for (var _i = 1; _i < str[0].length; _i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 1) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 1) + _s + '@' + str[1];
              }
            }
          }
        }

        return new_email;
      } else {
        var _new_email = email;

        if (String(email).indexOf('@') > 0) {
          var _str = email.split('@');

          var _s2 = '';

          if (_str[0].length > 3) {
            // @前面多于3位
            for (var _i2 = 3; _i2 < _str[0].length; _i2++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 3) + _s2 + '@' + _str[1];
          } else {
            // @前面小于等于于3位
            for (var _i3 = 1; _i3 < _str[0].length; _i3++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 1) + _s2 + '@' + _str[1];
          }
        }

        return _new_email;
      }
    },
    delRow: function delRow(index, data) {
      console.log('---delRow---');
    },
    handleClick: function handleClick() {// console.log('点击')
    },
    setXPhone: function setXPhone(tel) {
      if (tel.indexOf('-') != -1) {
        tel = ' ' + tel;
        var str = ' ';
        str = tel.substring(0, 4) + '****' + tel.substring(9);
        return str;
      } else {
        var phone = this.formData.enterpriseInfo.linkmanPhone; // 获取到被保人的电话信息

        phone = '' + phone;
        var reg = /(\d{3})\d{4}(\d{4})/; // 正则表达式

        var phone = phone.replace(reg, '$1****$2');
        this.formData.enterpriseInfo.linkmanPhone = phone;
        return phone;
      }
    },
    setLinkmanIdeNo: function setLinkmanIdeNo(tel) {
      // 证件号码
      if (tel != null && tel != undefined) {
        tel = ' ' + tel;
        var str = ' ';
        str = tel.substring(0, 4) + '****' + tel.substring(5);
        return str;
      }
    },
    prompt: function prompt(message) {
      this.$message({
        type: 'warning',
        message: message
      });
    },
    // 获取机构
    getCompany: function getCompany(index, data) {
      var _this = this;

      api.queryAll({
        insuranceCompanyCode: data.insuranceCompanyCode
      }).then(function (res) {
        _this.enterpriseInfo.sysCreditDtoList[index].companys = Object.assign([], res);
      });
    },
    getFullDate: function getFullDate(targetDate) {
      var D, y, m, d;

      if (targetDate) {
        D = new Date(targetDate);
        y = D.getFullYear();
        m = D.getMonth() + 1;
        d = D.getDate();
      } else {
        y = fullYear;
        m = month;
        d = date;
      }

      m = m > 9 ? m : m;
      d = d > 9 ? d : d;
      return d;
    },
    numberAdd: function numberAdd(arg1, arg2) {
      var r1, r2, m, n;

      try {
        r1 = arg1.toString().split('.')[1].length;
      } catch (e) {
        r1 = 0;
      }

      try {
        r2 = arg2.toString().split('.')[1].length;
      } catch (e) {
        r2 = 0;
      }

      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m + arg2 * m) / m).toFixed(n);
    },
    changeFile: function changeFile(file) {
      console.log('fil1111', file);
      this.fileList.push(file);
      console.log('this.fileList22--', this.fileList);
    },
    addEndDate: function addEndDate(value) {
      console.log('选择起保日期==', value);
      var newdate = new Date(value);
      newdate = newdate.setFullYear(newdate.getFullYear() + 1);
      var aa = new Date(new Date(newdate).getTime() - 24 * 60 * 60 * 1000);
      this.formData.endDate = aa;
    },
    getCoinData: function getCoinData() {
      var _this2 = this;

      coinData({
        codeLever: 1,
        codeType: ['currency']
      }).then(function (res) {
        console.log('rres', res);
        _this2.coinList = res[0].dictionary;
      });
    },
    changeDateStart: function changeDateStart(value) {
      var currentDate = this.getCurrentTime(); // 当前日期时间戳

      currentDate = this.getTimes(currentDate);
      var startTime = this.getTimes(value);

      if (startTime < currentDate) {
        this.$message.warning('选择日期应不小于当前日期');
      } else {
        var endTime = this.getEndDate(value, '1年');
        this.formData.insureRange.expectEndDate = endTime;
      }
    },
    // 获取用户信息
    getUserInfo: function getUserInfo() {
      var _this3 = this;

      api.getInfo({
        userId: this.$route.params.userId
      }).then(function (res) {
        _this3.formData.enterpriseInfo = Object.assign({}, res);
        console.log('getUserInfo=' + _this3.formData.enterpriseInfo);
        console.log(res.sysCreditDtoList);
        res.sysCreditDtoList.forEach(function (item) {
          item.companys = [{
            companyCode: item.companyCode,
            companyName: item.companyCodeName
          }];
        });

        if (res.accountType) {
          var data = {
            codeType: 'businessType' + res.accountType
          };
          api.getDataCodeAndName(data).then(function (res) {
            _this3.businessTypeSelect = Object.assign([], res);
          });
        } else {
          _this3.businessTypeSelect = [];
        }

        _this3.isNew = res.sysCreditDtoList.length;
        _this3.formData.enterpriseInfo = Object.assign({}, res);

        if (_this3.formData.enterpriseInfo.businessType != undefined && _this3.formData.enterpriseInfo.businessType != null && _this3.formData.enterpriseInfo.businessType != '') {
          _this3.businessTypeList = _this3.formData.enterpriseInfo.businessType.split(',');
        }

        _this3.businessTypeList.map(function (item, i) {
          if (item == '100') {
            _this3.ishyx = true;
          } else if (item == '101') {
            _this3.isxyx = true;
          } else if (item == '102') {
            _this3.isllx = true;
          }
        });
      });
    },
    getEndDate: function getEndDate(start, section) {
      var end = '';
      var startDate = new Date(start);

      if (section.indexOf('年')) {
        var sec = section.replace('年', '') - 0;
        startDate.setFullYear(startDate.getFullYear() + sec);
      } else if (section.indexOf('月')) {
        var _sec = section.replace('月', '') - 0;

        startDate.setMonth(startDate.getMonth() + _sec);
      } else {
        var _sec2 = section.replace('天', '') - 0;

        startDate.setDate(startDate.getDate() + _sec2);
      }

      startDate.setDate(startDate.getDate() - 1);
      end = this.dateFomat(startDate);
      return end;
    },
    dateFomat: function dateFomat(date) {
      var division = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
      return date.getFullYear() + division + this.supplementZero(date.getMonth() + 1) + division + this.supplementZero(date.getDate());
    },
    supplementZero: function supplementZero(num) {
      return num > 9 ? num : '0' + num;
    },
    changeDateEnd: function changeDateEnd(value) {
      var startTime = this.getTimes(this.formData.insureRange.expectStartDate);
      var endTime = this.getTimes(value);

      if (endTime < startTime) {
        this.$message.warning('选择日期应不小于保险期限起期');
      }
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, '/'); // 必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    // 获取当前日期
    getCurrentTime: function getCurrentTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (day < 10) {
        day = '0' + day;
      }

      var nowDate = year + '-' + month + '-' + day;
      return nowDate;
    },
    validPriceForm: function validPriceForm() {
      // 校验规则
      // 校验基本信息  投保范围 出口情况
      var baseValid = true;
      var rangeValid = false;
      var totalValid = false;
      this.$refs['formData.enterpriseInfo'].validate(function (valid) {
        if (valid) {
          baseValid = true;
        } else {
          baseValid = false;
        }
      });
      this.$refs['formData.insureRange'].validate(function (valid) {
        if (valid) {
          rangeValid = true;
        } else {
          rangeValid = false;
        }
      });
      this.$refs['formData'].validate(function (valid) {
        if (valid) {
          totalValid = true;
        } else {
          totalValid = false;
        }
      });
      return baseValid && rangeValid && totalValid;
    },
    cancleBtn: function cancleBtn() {
      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.push('/');
    },
    baseFunction: function baseFunction() {
      var _this4 = this;

      // 获取基础数据下拉列表的值
      baseInfo({}).then(function (res) {
        console.log('res结果', res);

        if (res.rtnCode === '0000') {
          _this4.businessNatures = res.businessNature;
          _this4.identifyType = res.personIdentifyType;
          _this4.companyType = res.companyType;
        }
      });
    },
    // 初始化的数据
    applyFunction: function applyFunction() {
      var _this5 = this;

      applyInfo({}).then(function (res) {
        console.log('res申请人信息', res);

        if (res.rtnCode === '0000') {
          _this5.formData.enterpriseInfo.companyDate = res.companyDate;
          _this5.formData.enterpriseInfo.businessStartDate = res.businessStartDate;
          _this5.formData.enterpriseInfo.businessEndDate = res.businessEndDate;
          _this5.formData.enterpriseInfo.enterName = res.insuredName;
          _this5.formData.enterpriseInfo.enterEnName = res.insuredEnName;
          _this5.formData.enterpriseInfo.identifyNumber = res.identifyNumber;
          _this5.formData.enterpriseInfo.authPersonName = res.authPersonName;
          _this5.formData.enterpriseInfo.authPersonName = res.authPersonName;
          _this5.formData.enterpriseInfo.authPersonIdeType = res.authPersonIdeType;
          _this5.formData.enterpriseInfo.authPersonIdeNo = res.authPersonIdeNo;
          _this5.formData.enterpriseInfo.businessRange = res.businessRange;
          _this5.formData.enterpriseInfo.linkmanName = res.linkmanName;
          _this5.formData.enterpriseInfo.linkmanPhone = res.linkmanPhone;
          _this5.formData.enterpriseInfo.linkmanIdeNo = res.linkmanIdeNo;
          _this5.formData.enterpriseInfo.linkmanEmail = res.linkmanEmail;
          _this5.formData.enterpriseInfo.linkmanIdeType = res.linkmanIdeType;
          _this5.formData.enterpriseInfo.isListed = res.isListed;
          _this5.formData.enterpriseInfo.businessType = res.businessType;
          _this5.formData.enterpriseInfo.companyType = res.companyType;
          _this5.formData.enterpriseInfo.registAddress = res.registAddress;
          _this5.formData.enterpriseInfo.businessAddress = res.businessAddress;
          _this5.formData.enterpriseInfo.businessStartYear = res.businessStartYear;
          _this5.formData.enterpriseInfo.businessScope = res.businessScope;
          _this5.formData.enterpriseInfo.businessNature = res.businessNature;
          _this5.formData.enterpriseInfo = res.lastTreYearBus;
          console.log('res.lastTreYearBus==', res.lastTreYearBus);
          console.log('this.formData.lastTreYearBus22==', _this5.formData.lastTreYearBus);
          _this5.formData.insuranceCompanyName = res.insuranceCompanyName;
          _this5.formData.insuranceCompanyCode = res.insuranceCompanyCode;
          _this5.formData.companyName = res.companyName;
          _this5.formData.companyType = res.companyType;
          _this5.insureRange = res.insureRange;
          res.overDueDays.forEach(function (item) {
            item.overDueDaysName = item.codeCname;
          });
          _this5.formData.overDue = res.overDueDays; // console.log('this.formData.overDue',this.formData.overDue)

          _this5.formData.lastTreUnCollect = res.lastTreUnCollect; // this.getFour()

          if (_this5.$route.params.type == 'view' || _this5.$route.params.type == 'edit') {
            console.log('查看/修改---');

            if (_this5.$route.params.type == 'edit') {
              _this5.formData.operateType = '2';
            }

            if (_this5.$route.params.type == 'view') {
              _this5.allDisabled = true;
            }

            _this5.formData.applicationNo = _this5.$route.params.applicationNo; // this.getList()
          }

          if (_this5.$route.params.type == 'view') {
            // 电话脱敏
            if (_this5.formData.enterpriseInfo.linkmanPhone != null && _this5.formData.enterpriseInfo.linkmanPhone != '') {
              _this5.formData.enterpriseInfo.linkmanPhone = _this5.setXPhone(_this5.formData.enterpriseInfo.linkmanPhone);
            } // 邮箱脱敏


            if (_this5.formData.enterpriseInfo.linkmanEmail != null && _this5.formData.enterpriseInfo.linkmanEmail != '') {
              _this5.formData.enterpriseInfo.linkmanEmail = _this5.setXEmail(_this5.formData.enterpriseInfo.linkmanEmail);
            } // 证件号码脱敏


            if (_this5.formData.enterpriseInfo.linkmanIdeNo != null && _this5.formData.enterpriseInfo.linkmanIdeNo != '') {
              _this5.formData.enterpriseInfo.linkmanIdeNo = _this5.setLinkmanIdeNo(_this5.formData.enterpriseInfo.linkmanIdeNo);
            }
          }
        }

        getApplicantInfo().then(function (res) {
          console.log('res--', res);
          var userId = res.userId;
          var data = {
            userId: userId,
            businessType: '101'
          };
          getCheckVerifyPermissions(data).then(function (res) {
            console.log('权限验证返回信息', res);

            if (res) {
              if (res.resultCode != '0000') {
                _this5.formData.insuranceCompanyName = '';
              }
            }
          });
        });
      });
    },
    toggleSelection: function toggleSelection(rows) {
      var _this6 = this;

      console.log('rows===', rows);

      if (rows) {
        rows.forEach(function (row) {
          _this6.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getFour: function getFour() {
      var _this7 = this;

      if (this.insureApplyRecord.length > 0) {} else {
        getRecord({
          auditRecordNo: this.formData.applicationNo
        }).then(function (res) {
          if (res.insureApplyRecord.length > 0) {
            _this7.insureApplyRecord = res.insureApplyRecord;
            console.log('获取审核记录', res);
          } else {
            _this7.$message({
              type: 'error',
              message: res.rtnMsg
            });
          }
        });
      }
    },
    beforeAvatarRemove: function beforeAvatarRemove(file, fileList) {
      var _this8 = this;

      console.log('file==删除', file);
      var id = '';

      if (file.isEdit && file.isEdit == '1') {
        id = file.id;
      } else if (file.response) {
        id = file.response.data[0].id;
      } else {
        id = file.uid;
      }

      if (file || file.status == 'success' || file.raw.type == 'application/pdf' || file.raw.type == 'image/jpeg' || file.raw.type == 'image/png') {
        var del = false;
        deleteFile({
          id: id
        }).then(function (res) {
          if (res.code == 200) {
            _this8.$message.success('删除成功');

            del = true;
            return del;
          }
        });
      }
    },
    sucess: function sucess() {},
    deleteImg: function deleteImg() {},
    beforeAvatarUploads: function beforeAvatarUploads() {},
    selectFile: function selectFile() {}
  }
};